import { FunctionComponent } from "react";
import Bitacora from "../../../pages/bitacora/Index";
import Reportes from "../../../pages/reportes/Main";
import Dashboard from "../../../pages/dashboard/Index";

const rutaOtros: Array<{ path: string, elemento: FunctionComponent }> = [
    { path: "/bitacora", elemento: Bitacora },
    { path: "/reportes", elemento: Reportes },
    { path: "/dashboard", elemento: Dashboard },
]

export default rutaOtros;